<app-status
    *ngIf="status && fieldType"
    [disabled]="true"
    [fieldType]="fieldType"
    [field]="status"
    [value]="value ?? ''"
>
</app-status>
